import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import { formatNumberToEurCurrency } from '#app/Util/NumberTool';
import { Product } from '#app/View/ClientService/OrderClientLitige';

type Props = {
  products: Product[];
  loading: boolean;
};

const List: React.FC<Props> = ({ products, loading }) => {
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: "Nom de l'article",
      flex: 2,
    },
    {
      field: 'depositAmount',
      headerName: 'Quantité disponible',
      flex: 1,
    },
    {
      field: 'amount',
      headerName: 'Quantité commandée',
      flex: 1,
    },
    {
      field: 'amountReturnReceived',
      headerName: 'Quantité retournée reçue',
      flex: 1,
    },
    {
      field: 'amountReturnCompliant',
      headerName: 'Quantité retournée conforme',
      flex: 1,
    },
    {
      field: 'amountRefund',
      headerName: 'Quantité remboursée',
      flex: 1,
    },
    {
      field: 'amountForwarding',
      headerName: 'Quantité réexpédiée',
      flex: 1,
    },
    {
      field: 'pricePaidTTC',
      headerName: 'Prix final ttc unitaire',
      flex: 1,
      valueGetter: (value) => formatNumberToEurCurrency(value),
    },
  ];

  return (
    <DataGrid
      loading={loading}
      rows={transformObjectToDataGridRowsArray<Product>(products)}
      columns={columns}
      hideFooter
      disableColumnSorting
    />
  );
};

export default List;
